import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class NutritionEducationController {

  constructor(options) {
    this.options = options;
    console.log('NUT ED CONTROLLER');

    this.general_comingsoon = new HeroComponent({
      elem      :'section.ourvalues__eggfacts',
    });

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      $('div.site__overlay').addClass('is-active');
      $('div.modal .modal__content').removeClass('dn');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal .modal__content').addClass('dn');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });
  }

  handleResize() {
  }

  handleScroll() {

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/NutritionEducationController.js